import InputMask from "react-input-mask";
import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { belemApi } from "../../services/belemApi";
import { getErrorMessage } from "../../utils/http";
import RecuperaPdf from "../../pdf/recProtocolo";
import {toast} from 'react-toastify';


export  default function Recuperar () {

   const [inputCPF, setInputCPF] = useState('');
  /// const [respost, setRespost] =useState();    

   async function recuperarProtocolo() {

    ///console.log(inputCPF)
        try{
          const cpf = String(inputCPF || '').trim();
          if (!cpf) {
            toast.info('Informe o CPF.');
            return;
          }
          const response = await belemApi.recuperarAgendamento(cpf);
         /// setRespost(response[0].data);
         if (response.data.length === 0){
            toast.error("O agendamento não foi encontrado no posto.")
          }
         const recupera = response.data;
                   RecuperaPdf(recupera)
        }catch(err){
          toast.error(getErrorMessage(err));
        }
         
    }
    return(
        <div className="flex flex-col  md: py-20">
          
           <div className="flex justify-center text-center md: py-10">
                <h1 className="font-loto font-bold  text-letras2   py-4 text-xl">Recuperar Protocolo de Agendamento</h1>
            </div>
           <div className="flex justify-center items-center  mx-20 ">
              <label className="font-abc font-bold uppercase text-xl text-letras2 m-5 ">CPF:</label><br/><br/>
                 <InputMask type="text" mask="999.999.999-99"  className="focus:outline-none border-b w-[15rem]  rounded-t-lg px-2 border-letras2 font-abc bg-card/[.25] h-10" value={inputCPF}   onChange={ (e) => setInputCPF(e.target.value)} />
            </div>
         <div className=" flex flex-wrap justify-center  pb-40">
            <div className="flex  justify-center pr-2">
               <button className=" rounded-full px-1  w-28 h-8 bg-green hover:bg-letras2 hover:text-2 cursor-pointer  text-white text-lg font-semibold "  onClick={ () => recuperarProtocolo()}>
                   Recuperar
                </button>  
            </div>
         
            <div className="flex  justify-center">
               <Link to={'/'}>
               <button className=" rounded-full px-1 w-28  h-8 bg-green hover:bg-letras2 hover:text-2 cursor-pointer  text-white text-lg font-semibold " >
                   Voltar
                </button>
                </Link>  
            </div>
            
         </div>

        </div>
       
    )
}